import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesCreateViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesCreateViewEntryPoint: EntryPoint<QueuesCreateViewEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<QueuesCreateViewEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-csm-queues-create-view", jiraSpaEntry: "async-servicedesk-csm-queues-create-view" */ './ExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
